"use client";

import { Avatar, Card, CardContent, RenderIf } from "@repo/ui";
import { LinkedinIcon } from "@spoctech/icons";
import { Quote, CircleUser } from "lucide-react";
import Image from "next/image";

type LearnerCardProps = {
  src?: string;
  feedback: string;
  name: string;
  designation: string;
  outlined?: boolean;
  linkedinUrl?: string;
  facebookUrl?: string;
  twitterUrl?: string;
  instagramUrl?: string;
};

const LearnerCard = ({
  src,
  feedback,
  name,
  designation,
  outlined = false,
  linkedinUrl,
}: LearnerCardProps) => {
  return (
    <Card className="h-full rounded-2xl" elevation="none" outlined={outlined}>
      <CardContent className="p-8 flex flex-col h-full">
        <Quote className="text-secondary-main w-12 h-12 mb-6 scale-x-[-1]" />
        <div className="flex flex-col gap-5 flex-1  justify-between">
          <div className="space-y-6 ">
            <p className="text-gray-700 text-lg leading-relaxed">{feedback}</p>
          </div>

          <div className="flex items-center gap-4">
            <RenderIf
              condition={Boolean(src)}
              fallback={
                <Avatar className="!size-20  !text-gray-500 !bg-transparent">
                  <CircleUser size={80} strokeWidth={1} />
                </Avatar>
              }
            >
              {src && (
                <Image
                  src={src}
                  aria-label={name}
                  alt={name}
                  width={80}
                  height={80}
                  className="size-20 object-cover rounded-full border-4 border-secondary-main/20"
                />
              )}
            </RenderIf>
            <div>
              <div className="text-xl font-semibold text-primary-main">
                {name}
              </div>
              <p className="text-gray-600">{designation}</p>
            </div>
            {linkedinUrl && (
              <a
                href={linkedinUrl}
                title="LinkedIn"
                className="block justify-self-end ml-auto"
              >
                <LinkedinIcon className="text-primary-light" />
              </a>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LearnerCard;
